'use client';

import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import { CURATION_SHOP_NOT_FOUND_ERROR_MESSAGE } from '@musinsa/services-curator';
import { useQuery } from '@tanstack/react-query';
import { notFound } from 'next/navigation';
import { getPaths } from '../../common';
import { useNavigate } from '../../common/hooks/useNavigate';
import { curatorQueries } from '../../query-factory';

interface ShopRedirectHandlerProps {
  shopSlug: string;
  searchParams: { [key: string]: string | string[] | undefined };
}

/**
 * 방문자용 큐레이터 프로필을 조회하여 내 샵인지 확인하고 리다이렉트 처리하는 클라이언트 컴포넌트
 * FIXME: Server Component로 처리되면 사용자 경험 상 이점이 있으나, 29cm 쿠키전달 이슈로 적용하지 못했음
 */
export function ShopRedirectHandler({ shopSlug, searchParams }: ShopRedirectHandlerProps) {
  const { service, isWebview } = useDeviceInfo();
  const { navigateReplace } = useNavigate();
  const paths = getPaths(service);

  const {
    data: profile,
    isError,
    error,
  } = useQuery({
    ...curatorQueries.profile.profileBySnsTitle(shopSlug),
  });

  // 404 에러인 경우 not-found 페이지로 이동
  if (isError && error instanceof Error) {
    if (error.message === CURATION_SHOP_NOT_FOUND_ERROR_MESSAGE) {
      return notFound();
    }
  }

  // 내 샵인 경우 리다이렉트
  if (profile?.isMyShop) {
    // 현재 쿼리스트링을 평문 객체로 변환 (paths의 query 옵션 형식)
    const query: Record<string, string> = {};
    Object.entries(searchParams).forEach(([key, value]) => {
      if (value === undefined) return;
      // Array는 첫 값만 사용 (defineRoute의 query 옵션이 단일 값 기준)
      query[key] = Array.isArray(value) ? value[0] : value;
    });

    // NOTE: 무신사 웹뷰에서 direct=true 누락 시 OneLink 리다이렉트로 재진입 루프가 발생하므로 보강
    if (service === SERVICE.MUSINSA && isWebview && !('direct' in query)) {
      query.direct = 'true';
    }

    // service 분기는 paths.myShop()이 자동 처리 (29CM은 snsTitle 무시, Musinsa는 path 인자 사용)
    navigateReplace(paths.myShop({ snsTitle: shopSlug, query }));
  }

  // UI를 렌더링하지 않음
  return null;
}
